export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20coral%20and%20sandy%20beige%20tones%20flowing%20together%20organically%2C%20subtle%20texture%20resembling%20brushed%20suede%20fabric%2C%20gentle%20light%20diffusion%2C%20minimalist%20artistic%20composition%2C%20no%20distinct%20objects%2C%20serene%20warm%20atmosphere%2C%20editorial%20quality&width=1600&height=800&seq=cta-bg-v2-warm-017&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/70"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight mb-5">
          Start Exploring the Latest{" "}
          <span className="italic">Vigorbuy Spreadsheet</span>{" "}
          Today
        </h2>
        <p className="text-base md:text-lg text-background-50/75 max-w-xl mx-auto mb-8 leading-relaxed">
          Join thousands of users who save time and discover better products with the updated Vigorbuy Spreadsheet 2026.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap text-center cursor-pointer"
          >
            Explore the Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 rounded-full border-2 border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-all whitespace-nowrap text-center cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}